import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ProgressBar } from "react-bootstrap";

const AnimateLoading = () => {
  const [width, setWidth] = useState(0);
  const location = useLocation();
  const animateTimeoutRef = useRef(null);
  const stopAnimateTimeoutRef = useRef(null);

  useEffect(() => {
    // Start animation when the route changes
    animate(0);

    // Scroll to top when the route changes
    scrollToTop();

    // Clean up function
    return () => {
      clearTimeout(animateTimeoutRef.current);
      clearTimeout(stopAnimateTimeoutRef.current);
    };
  }, [location]);

  const scrollToTop = () => {
    const scrollToTopBtn = document.getElementById("kt_scrolltop");
    if (scrollToTopBtn) {
      scrollToTopBtn.click();
    }
  };

  const animate = (currentWidth) => {
    if (currentWidth < 100) {
      animateTimeoutRef.current = setTimeout(() => {
        setWidth(currentWidth + 10);
        animate(currentWidth + 10);
      }, 30);
    } else {
      stopAnimate();
    }
  };

  const stopAnimate = () => {
    clearTimeout(animateTimeoutRef.current);
    stopAnimateTimeoutRef.current = setTimeout(() => {
      setWidth(0);
    }, 300);
  };

  return (
    <div
      className="header-progress-bar"
      style={{ height: "2px", width: "100%" }}>
      {width > 0 && (
        <ProgressBar variant="primary" now={width} style={{ height: "2px" }} />
      )}
    </div>
  );
};

export default AnimateLoading;
